export type ReaderContentViewVariant = 'mobile' | 'desktop';

export enum ReaderScrollDirection {
  UP = 'up',
  DOWN = 'down'
}
